import React, { useEffect, useRef, useState, useTransition } from "react";
import { Link } from "react-router-dom";
import SideBarSubMenu from "./SideBarSubMenu";
import { useContext } from "react";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
import SideBarMenu from "./SideBarMenu";
import Skeleton from "react-loading-skeleton";
import logo from "./../../../logo.jpg";
const SideBar = ({ menuSHow, setMenuShow }) => {
  const { authUser } = useContext(AuthContext);

  const [liveChatData, setLiveChatData] = useState(0);
  const [notificationData, setNotificationData] = useState([]);

  useEffect(() => {
    const interval = setInterval(fetchData, 2000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = async () => {
    try {
      const [notificationRes, liveChatRes] = await Promise.all([
        fetch("https://api.velormall.com/api/admin/notification/view", {
          method: "GET",
        }),
        fetch("https://live-chat-api.velormall.com/api/admin/notification/view", {
          method: "GET",
        }),
      ]);

      if (!notificationRes.ok || !liveChatRes.ok) {
        throw new Error("Failed to fetch notification data");
      }

      const [notificationData, liveChatData] = await Promise.all([
        notificationRes.json(),
        liveChatRes.json(),
      ]);

      if (notificationData?.success) {
        setNotificationData(notificationData?.notificationData);
      }

      if (liveChatData?.success) {
        setLiveChatData(liveChatData?.PendingLiveChats ?? 0);
      }
    } catch (error) {
      console.error("Notification fetch error:", error);
    }
  };

  const routes = [
    {
      path: "/admin/dashboard",
      name: "Dashboard",
      icon: "menu-icon las la-home",
    },

    {
      path: "/admin/platform-type/view",
      name: "Platform Type",
      icon: "menu-icon las la-cog",
    },
    {
      path: "/admin/platform-rules/view",
      name: "Platform Rules",
      icon: "menu-icon las la-cog",
    },
    {
      path: "/admin/product/view",
      name: "Products",
      icon: "menu-icon las la-cog",
    },
    {
      path: "order",
      name: "Orders",
      icon: "menu-icon las la-cog",
    },
    {
      path: "/admin/order-set",
      name: "Order Set",
      icon: "menu-icon las la-cog",
    },

    {
      path: "/admin/staff",
      name: "Manage Staff",
      icon: "menu-icon la-user-astronaut",
    },



    {
      path: "/settings",
      name: "Manage Users",
      icon: "menu-icon las la-users",
      notification: notificationData?.TotalUser,
      subRoutes: [
        {
          path: "/admin/users/active",
          name: "Active Users",
          notification: notificationData?.ActiveUser,
        },
        {
          path: "/admin/users/banned",
          name: "Banned Users",
          notification: notificationData?.BannedUser,
        },
        {
          path: "/admin/users/email-unverified",
          name: "Email Unverified",
        },
        {
          path: "/admin/users/mobile-unverified",
          name: "Mobile Unverified",
        },
        {
          path: "/admin/users/kyc-unverified",
          name: "KYC Unverified",
        },
        {
          path: "/admin/users/kyc-pending",
          name: "KYC Pending",
          notification: notificationData?.KYCPendingUser,
        },
        {
          path: "/admin/users/with-balance",
          name: "With Balance",
        },
        {
          path: "/admin/users/all",
          name: "All Users",
        },
      ],
    },


    {
      path: "",
      name: "Deposits",
      icon: "menu-icon las la-file-invoice-dollar",
      notification: notificationData?.TotalDeposit,
      subRoutes: [
        {
          path: "/admin/deposit/method",
          name: "Deposits Method",
        },
        {
          path: "/admin/deposit/pending",
          name: "Pending Deposits",
          notification: notificationData?.PendingDeposit,
        },
        {
          path: "/admin/deposit/approved",
          name: "Approved Deposits",
          notification: notificationData?.ApprovedDeposit,
        },
        {
          path: "/admin/deposit/rejected",
          name: "Rejected Deposits",
          notification: notificationData?.RejectedDeposit,
        },
        {
          path: "/admin/deposit",
          name: "All Deposits",
        },
      ],
    },
    {
      name: "Withdrawals",
      icon: "menu-icon la la-bank",
      notification: notificationData?.TotalWithdrawal,
      subRoutes: [
        {
          path: "/admin/withdraw/method",
          name: "Withdrawal Methods",
        },
        {
          path: "/admin/withdraw/pending",
          name: "Pending Withdrawal",
          notification: notificationData?.PendingWithdrawal,
        },
        {
          path: "/admin/withdraw/approved",
          name: "Approved Withdrawal",
          notification: notificationData?.ApprovedWithdrawal,
        },
        {
          path: "/admin/withdraw/rejected",
          name: "Rejected Withdrawal",
          notification: notificationData?.RejectedWithdrawal,
        },
        {
          path: "/admin/withdraw/log",
          name: "All Withdrawal",
        },
      ],
    },

    {
      name: "Mining",
      icon: "menu-icon la la-bank",
      subRoutes: [
        {
          path: "/admin/running/mining/view",
          name: "Promotion",
        },
        {
          path: "/admin/user/running/mining/view",
          name: "Running Mining",
        },
        {
          path: "/admin/user/complete/mining/view",
          name: "Complete Mining",
        },
        {
          path: "/admin/user/all/mining/view",
          name: "All Mining",
        },
      ],
    },


    {
      chat: true,
      path: `https://admin-live-chat.velormall.com/authorized/${authUser?._id}`,
      name: "Live Chats",
      icon: "menu-icon la-thumbs-up",
      notification: liveChatData,
    },

    {
      path: "/admin/notices/view",
      name: "Notices",
      icon: "menu-icon la-user-astronaut",
    },


  ];

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  const menuRef = useRef();

  const [mobileMenu, setMobileMenu] = useState();

  useEffect(() => {
    if (menuSHow === true) {
      menuRef.current.style.left = "0px";
    }
    if (mobileMenu === true) {
      menuRef.current.style.left = "-800px";
      setMenuShow(false);
      setMobileMenu(false);
    }
  }, [mobileMenu, menuSHow]);

  return (
    <>
      <div className="default-version">
        <div className="sidebar bg--dark">
          <button
            className="res-sidebar-close-btn"
            onClick={() => setMobileMenu(true)}
          >
            <i className="las la-times"></i>
          </button>
          <div className="sidebar__inner">
            <div className="sidebar__logo">
              <Link to="/admin/dashboard" className="sidebar__main-logo d-flex align-items-center justify-content-center">
                {/* <img
                  src="https://res.cloudinary.com/debfkqhc8/image/upload/v1743102297/npxfpnd7fuu3t7monxwv.jpg"
                  alt=""
                /> */}
                <p className="pt-3 m-0 text-light bold fs-6">
                  VMall
                </p>
              </Link>
            </div>

            <div className="sidebar__menu-wrapper" id="sidebar__menuWrapper">
              <ul className="sidebar__menu">
                {routes.map((route, index) => {
                  if (authUser?._id === undefined) {
                    return (
                      <>
                        <Skeleton
                          count={20}
                          height={10}
                          baseColor="#202020"
                          highlightColor="#444"
                        />
                      </>
                    );
                  } else {
                    if (route.subRoutes) {
                      return (
                        <SideBarSubMenu
                          setIsOpen={setIsOpen}
                          route={route}
                          showAnimation={showAnimation}
                          isOpen={isOpen}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        />
                      );
                    } else if (route.title) {
                      return (
                        <li className="sidebar__menu-header" key={index}>
                          {route.title}
                        </li>
                      );
                    } else {
                      return (
                        <SideBarMenu
                          route={route}
                          index={index}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        ></SideBarMenu>
                      );
                    }
                  }
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="default-version desltop-version">
        <div className="sidebar bg--dark" ref={menuRef}>
          <button
            className="res-sidebar-close-btn"
            onClick={() => setMobileMenu(true)}
          >
            <i className="las la-times"></i>
          </button>
          <div className="sidebar__inner">
            <div className="sidebar__logo">
              <Link href="/admin/dashboard" className="sidebar__main-logo">
                {/* <img
                  src=""
                  alt=""
                /> */}
              </Link>
            </div>
            <div className="sidebar__menu-wrapper" id="sidebar__menuWrapper">
              <ul className="sidebar__menu">
                {routes.map((route, index) => {
                  if (authUser?._id === undefined) {
                    return (
                      <>
                        <Skeleton
                          count={20}
                          height={10}
                          baseColor="#202020"
                          highlightColor="#444"
                        />
                      </>
                    );
                  } else {
                    if (route.subRoutes) {
                      return (
                        <SideBarSubMenu
                          setIsOpen={setIsOpen}
                          route={route}
                          showAnimation={showAnimation}
                          isOpen={isOpen}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        />
                      );
                    } else if (route.title) {
                      return (
                        <li className="sidebar__menu-header" key={index}>
                          {route.title}
                        </li>
                      );
                    } else {
                      return (
                        <SideBarMenu
                          route={route}
                          index={index}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        ></SideBarMenu>
                      );
                    }
                  }
                })}



              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
